/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum HivScreeningPlace {
    HEALTH_CENTER = 'healthCenter',
    HOSPITAL = 'hospital',
    CONSULTATIVE_DEPARTMENT = 'consultativeDepartment',
    NGO = 'ngo',
    YOUTH_FRIENDLY_CENTER = 'youthFriendlyCenter',
    SELF_TESTING = 'selfTesting',
    PENITENTIARY = 'penitentiary',
    OTHER = 'other',
}
